(function () {
  // Detecta el producto actual y sus variantes
  function getVariantData(scope) {
    var form = scope.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    var variantDataEl = form.querySelector('[type="application/json"]');
    if (!variantDataEl) return null;

    try {
      return JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  // Marca y oculta swatches agotados
  function markSoldOutSwatches(scope) {
    var variants = getVariantData(scope);
    if (!variants) return;

    var optionNames = (variants[0] && variants[0].options) ? variants[0].options.map((_, i) => i) : [];

    optionNames.forEach(function (optionIndex) {
      var optionValues = Array.from(new Set(variants.map(v => v.options[optionIndex])));

      optionValues.forEach(function (value) {
        var matchingVariants = variants.filter(v => v.options[optionIndex] === value);
        var isAvailable = matchingVariants.some(v => v.available);

        var selector = `.swatch-element[data-value="${value}"], .swatch__item[data-value="${value}"]`;
        scope.querySelectorAll(selector).forEach(function (el) {
          if (!isAvailable) {
            el.classList.add('soldout');
            el.style.display = 'none';
          } else {
            el.classList.remove('soldout');
            el.style.display = '';
          }
        });
      });
    });
  }

  function init(scope) {
    if (!scope) scope = document;
    markSoldOutSwatches(scope);
  }

  // Al cargar
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-single, .product').forEach(function (prod) {
      init(prod);
    });
  });

  // Cada vez que cambia una variante
  document.addEventListener('variant:change', function (e) {
    var prod = e.target.closest('.product-single, .product');
    init(prod);
  });

  // Cuando Shopify recarga secciones
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
